import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface Task {
  id: string;
  user_id: string;
  file_name: string;
  file_size: number;
  status: string;
  error_msg?: string;
  created_at: number;
  updated_at: number;
}

interface TasksState {
  tasks: Task[];
  loading: boolean;
  error: string | null;
  pagination: {
    page: number;
    pageSize: number;
    total: number;
    totalPages: number;
  };
  lastFetchTime: number | null;
  cacheDuration: number;
  setTasks: (tasks: Task[]) => void;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
  setPagination: (pagination: Partial<TasksState['pagination']>) => void;
  isCacheValid: () => boolean;
  invalidateCache: () => void;
}

export const useTasksStore = create<TasksState>()(
  persist(
    (set, get) => ({
      tasks: [],
      loading: false,
      error: null,
      pagination: {
        page: 1,
        pageSize: 20,
        total: 0,
        totalPages: 0,
      },
      lastFetchTime: null,
      cacheDuration: 5 * 60 * 1000, // 5分钟缓存

      setTasks: (tasks) => set({ tasks, lastFetchTime: Date.now() }),

      setLoading: (loading) => set({ loading }),

      setError: (error) => set({ error }),

      setPagination: (pagination) =>
        set((state) => ({
          pagination: { ...state.pagination, ...pagination },
        })),

      isCacheValid: () => {
        const { lastFetchTime, cacheDuration } = get();
        if (!lastFetchTime) return false;
        return Date.now() - lastFetchTime < cacheDuration;
      },

      invalidateCache: () => set({ tasks: [], lastFetchTime: null }),
    }),
    {
      name: 'tasks-storage',
      partialize: (state) => ({
        tasks: state.tasks,
        pagination: state.pagination,
        lastFetchTime: state.lastFetchTime,
      }),
    }
  )
);
